import { useState } from 'react';

function SearchBar(props) {
	const [value, setValue] = useState('');

	const onChange = evt => {
		setValue(evt.target.value);
	};

	const onSubmit = evt => {
		evt.preventDefault();
		props.onChange(value);
	};

	// Style inline-block to be consistent with all the other elements
	return (<form onSubmit={onSubmit} style={{display: "inline-block"}}>
		<input value={value} onChange={onChange} placeholder="Country" />
		<button>Search</button>
	</form>);
}

export default SearchBar;
